export const FONT_BASE = 'default';
export const DEFAULT_FONT = {
    id: FONT_BASE,
    name: 'Default',
    family: 'Roboto',
    filepath: '/platform/pdf_fonts/base/index.json'
};
export const FONTS_LIST = [
    DEFAULT_FONT,
    {
        id: 'vtb',
        name: 'VTB Group',
        family: 'VTB',
        filepath: '/platform/pdf_fonts/vtb/index.json'
    },
];
